const btnPlayVideo_1 = document.getElementById("play_video_1");
const btnPlayVideo_2 = document.getElementById("play_video_2");
const btnPlayVideo_3 = document.getElementById("play_video_3");
const modalPlayVideo = document.getElementById("modalPlayVideo");
const contentVideo = document.getElementById("content_video");
const btnCloseModal = document.getElementById("close_modal");

const listVideo = [
	{
		id: 1,
		src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-1.mp4",
	},
	{
		id: 2,
		src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-2.mp4",
	},
	{
		id: 3,
		src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-3.mp4",
	},
];

function openVideoModal(videoId) {
	const video = listVideo.find((v) => v.id === videoId);
	if (video) {
		contentVideo.src = video.src;
		modalPlayVideo.classList.remove("hidden");
		contentVideo.play();
	}
}

btnPlayVideo_1.addEventListener("click", () => openVideoModal(1));
btnPlayVideo_2.addEventListener("click", () => openVideoModal(2));
btnPlayVideo_3.addEventListener("click", () => openVideoModal(3));

btnCloseModal.addEventListener("click", () => {
	modalPlayVideo.classList.add("hidden");
	contentVideo.pause();
	contentVideo.src = "";
});
